import { Pipe } from "@angular/core";

export class ListItemModel {
    public _class: string;

    public id: string;
    public name: string;
    public sublabel: string;
    public attrs: string;
    public type: string;
    public thumbnail: string;

    public meta1: string;

    public sideload: any;

    constructor(id: string, name: string, sublabel:string = '', attrs:string = '', sideload:any = null) {
        this.id = id || '';
        this.name = name || '';
        this.sublabel = sublabel || '';
        this.attrs = attrs || '';
        this.sideload = sideload || null;
    }
}
